import { getCurrentAppState } from "../components/AlmeApp/AlmeAppState";
export function updateCurrentRequiresQualtricsCookieValue(value, almeAppProps) {
    const props = {
        CookieName: "requiresQualtrics=",
        Type: value,
    };
    if (doesRequiresQualtricsCookieExist() === false) {
        setCurrentRequiresQualtricsCookieValue(props, almeAppProps);
    }
    else {
        if (getCurrentRequiresQualtricsCookieValue() !== value) {
            setCurrentRequiresQualtricsCookieValue(props, almeAppProps);
        }
    }
}
function doesRequiresQualtricsCookieExist() {
    const cookieName = "requiresQualtrics=";
    const currentCookies = decodeURIComponent(document.cookie);
    const splitCurrentCookies = currentCookies.split(';');
    for (const currentFocusedCookie of splitCurrentCookies) {
        if (currentFocusedCookie.includes(cookieName)) {
            return true;
        }
    }
    return false;
}
export function getCurrentRequiresQualtricsCookieValue() {
    const cookieName = "requiresQualtrics=";
    const currentCookies = decodeURIComponent(document.cookie);
    const splitCurrentCookies = currentCookies.split(';');
    for (const currentFocusedCookie of splitCurrentCookies) {
        if (currentFocusedCookie.includes(cookieName)) {
            return currentFocusedCookie.substring(cookieName.length + 1, currentFocusedCookie.length);
        }
    }
    return "false";
}
export function setCurrentRequiresQualtricsCookieValue(props, almeAppProps) {
    var _a;
    const almeAppState = getCurrentAppState();
    const cookieExpirationDate = new Date();
    cookieExpirationDate.setTime(cookieExpirationDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    const expireTime = "expires=" + cookieExpirationDate.toUTCString();
    let languageCode = "us|en";
    if (((_a = window._SFDDL) === null || _a === void 0 ? void 0 : _a.pageInfo.Country_Language) === "us|es" || almeAppState.isSpanishLiveChatConnected) {
        languageCode = "us|es";
    }
    if (props.Type === "true") {
        document.cookie = props.CookieName + 'true' + ";" + expireTime + ";path=/";
        document.cookie = "QSurveyLang=" + languageCode + ";" + expireTime + ";path=/";
    }
    else if (props.Type === "false") {
        document.cookie = props.CookieName + 'false' + ";" + expireTime + ";path=/";
    }
}
export function updateQSurveyLangCookieForSpanish() {
    const cookieExpirationDate = new Date();
    cookieExpirationDate.setTime(cookieExpirationDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    const expireTime = "expires=" + cookieExpirationDate.toUTCString();
    document.cookie = "QSurveyLang=" + 'us|es' + ";" + expireTime + ";path=/";
}
export function deleteCurrentRequiresQualtricsCookie() {
    document.cookie = "requiresQualtrics=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "QSurveyLang=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
